import React from "react";
import { Button } from "@shoptet/ui";
import { useTranslation } from "react-i18next";
import {
  useDeleteAssetLineMutation,
  useDisapproveSuggestionMutation,
  useRestoreDraftRemoveAssetLineMutation,
} from "../../graphql/generated/graphql";
import { useHandleApolloError } from "../../hooks/useHandleApolloError";

type DeleteAssetlineActionPropsT = {
  deleteDraft?: boolean;
  draft?: boolean;
  id: string;
  width: string;
};
export const DeleteAssetLineAction = ({ deleteDraft, draft, id }: DeleteAssetlineActionPropsT) => {
  const { t } = useTranslation("translation", { keyPrefix: "Components.AssetLineActions" });
  const [deleteAssetLine, {}] = useDeleteAssetLineMutation();
  const handleApolloError = useHandleApolloError();
  return (
    <Button
      variant={deleteDraft ? "primary" : "destructive"}
      onClick={async () => {
        try {
          await deleteAssetLine({ variables: { id, draft } });
        } catch (error) {
          handleApolloError(error);
        }
      }}
    >
      {deleteDraft ? t("Cancel creation") : t("Remove")}
    </Button>
  );
};

type RestoreDeleteDraftStateAssetlineActionPropsT = {
  id: string;
  width?: string;
};
export const RestoreDeleteDraftStateAssetlineAction = ({ id }: RestoreDeleteDraftStateAssetlineActionPropsT) => {
  const [restoreDeleteAssetLine, {}] = useRestoreDraftRemoveAssetLineMutation();
  const { t } = useTranslation("translation", { keyPrefix: "Components.AssetLineActions" });
  const handleApolloError = useHandleApolloError();
  return (
    <Button
      variant="primary"
      onClick={async () => {
        try {
          await restoreDeleteAssetLine({ variables: { id } });
        } catch (error) {
          handleApolloError(error);
        }
      }}
    >
      {t("Cancel removal")}
    </Button>
  );
};

type DisapproveSuggestionActionPropsT = {
  disabled?: boolean;
  id: string;
  kind?: string;
};
export const DisapproveSuggestionAction = ({ disabled, id, kind }: DisapproveSuggestionActionPropsT) => {
  const { t } = useTranslation("translation", { keyPrefix: "Components.AssetLineActions" });
  const [disapprove, {}] = useDisapproveSuggestionMutation();
  const handleApolloError = useHandleApolloError();

  return (
    <Button
      data-test-id={`${kind}-disapprove`}
      disabled={disabled}
      variant="primary"
      onClick={async () => {
        try {
          await disapprove({ variables: { id } });
        } catch (error) {
          handleApolloError(error);
        }
      }}
    >
      {t("Disapprove")}
    </Button>
  );
};
